import PermissionRow from "../administration/userManagement/permissionsTemplates/PermissionRow";
import {AccessRights} from "../constants";
import {Feature, isEnabled} from "../features/index";
import messageResource from '../messageResource'

export function generatePermissionRows ($firstGroupContainer, $secondGroupContainer) {
    const permissionsRows = {}
    permissionsRows[AccessRights.MANAGE_USERS] = new PermissionRow($firstGroupContainer, AccessRights.MANAGE_USERS, {
        name: messageResource.getMessage('access_rights.manage_users'),
    }).init();
    permissionsRows[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] = new PermissionRow($firstGroupContainer, AccessRights.SUBMIT_OTHER_USER_TIME_TRACK, {
        name: messageResource.getMessage(
            isEnabled(Feature.TTA) ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track'),
    }).init();
    permissionsRows[AccessRights.EDIT_HIERARCHY] = new PermissionRow($firstGroupContainer, AccessRights.EDIT_HIERARCHY, {
        name: messageResource.getMessage('access_rights.edit_hierarchy'),
    }).init();
    permissionsRows[AccessRights.GENERATE_MONEY_REPORTS] = new PermissionRow($firstGroupContainer, AccessRights.GENERATE_MONEY_REPORTS, {
        name: messageResource.getMessage('access_rights.generate_money_reports'),
    }).init();
    permissionsRows[AccessRights.SUBMIT_TIME_TRACK] = new PermissionRow($secondGroupContainer, AccessRights.SUBMIT_TIME_TRACK, {
        name: messageResource.getMessage('access_rights.submit_time_track'),
    }).init();
    permissionsRows[AccessRights.LOCK_TIME_TRACK] = new PermissionRow($secondGroupContainer, AccessRights.LOCK_TIME_TRACK, {
        name: messageResource.getMessage('access_rights.lock_time_track'),
    }).init();
    permissionsRows[AccessRights.MANAGE_PTO_AND_SICK] = new PermissionRow($secondGroupContainer, AccessRights.MANAGE_PTO_AND_SICK, {
        name: messageResource.getMessage('access_rights.manage_pto_and_sick'),
    }).init();
    permissionsRows[AccessRights.MANAGE_GENERAL_SETTINGS] = new PermissionRow($secondGroupContainer, AccessRights.MANAGE_GENERAL_SETTINGS, {
        name: messageResource.getMessage('access_rights.manage_general_settings'),
    }).init();
    return permissionsRows;
}


export function getManagePtoAndSickDaysRightTitle(isPtoEnabled, isSdbEnabled) {
    let title = ''
    if (isPtoEnabled && isSdbEnabled)
        title = messageResource.getMessage('access_rights.manage_pto_and_sick')
    else if (isPtoEnabled)
        title = messageResource.getMessage('access_rights.manage_pto_only')
    else if (isSdbEnabled)
        title = messageResource.getMessage('access_rights.manage_sick_only')

    return title
}

export const getGenerateMoneyReportsRightTitle = (isURAEnabled, isBTYEnabled) => {
    let generateMoneyReportsTitle = ""
    if (isBTYEnabled && isURAEnabled)
        generateMoneyReportsTitle = messageResource.getMessage('access_rights.generate_money_reports')
    if (isBTYEnabled && !isURAEnabled)
        generateMoneyReportsTitle = messageResource.getMessage('access_rights.generate_money_reports_only_billing')
    if (!isBTYEnabled && isURAEnabled)
        generateMoneyReportsTitle = messageResource.getMessage('access_rights.generate_money_reports_only_cost')

    return generateMoneyReportsTitle
}



// WEBPACK FOOTER //
// ./web/js/permissions/PermissionsUtils.js